module.exports = __webpack_public_path__ + "static/media/pfx.15ab37f5.svg";